import { render } from "./fail.vue?vue&type=template&id=6b8166b3&scoped=true"
import script from "./fail.vue?vue&type=script&lang=ts"
export * from "./fail.vue?vue&type=script&lang=ts"

import "./fail.vue?vue&type=style&index=0&id=6b8166b3&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6b8166b3"

export default script